export { CatchBoundary, ErrorBoundary, default, links, meta } from "/Users/julian/work/personal/wwsu-2022/app/root.tsx";